import { ReactNode } from "react";
import { Link } from "react-router-dom";
import ProductGridItem from "../items/ProductGridItem";
import { IProductSearchResult, IWarehouse } from "../../models/product/IProductSearchResult";
import { IRelatedProduct } from "../../queries/ProductPageRelatedQuery";
import ItemContainer from "../items/ItemContainer";
import ProductCarousel from "../ProductCarousel/ProductCarousel";
import ProductCartCarousel from "../ProductCartCarousel/ProductCartCarousel";

// export type ICollectionType = "COOKIE" | "NOP" | "Algolia";
export type ICollectionLayout = "Vertical" | "Carousel" | "CartCarousel" | "Grid";
// interface IPorpsVertical  {
//     layout: "Vertical";
//     products: ICollectionData[];
// }

interface IProps {
  layout: ICollectionLayout;
  products: ICollectionData[];
  title: ReactNode;
  seeMoreTo: string;
}
export interface ICollectionData extends IRelatedProduct {
  warehouse: IWarehouse | null;
}

// type IProps = (IPorpsVertical| IPorpsCarousel);
const Collection = (props: IProps) => {
  return (
    <div>
      {
        {
          Vertical: <Vertical title={props.title} products={props.products}></Vertical>,
          Carousel: <ProductCarousel seeMoreTo={props.seeMoreTo} relatedItems={props.products} title={props.title} />,
          CartCarousel: <ProductCartCarousel products={props.products} seeMoreTo={props.seeMoreTo || ""} />,
          Grid: (
            <div className="w-full">
              {props.title && <div className="mb-6">{props.title}</div>}
              <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
                {props.products.map((product) => (
                  <ProductGridItem
                    key={product.id}
                    item={{
                      approvedRatingSum: product.approvedRatingSum,
                      additionalShippingCharge: 0,
                      id: product.id,
                      name: product.name,
                      seoName: product.seoName,
                      partInterchange: [],
                      priceAndAvailability: product.priceAndAvailability,
                      manufacturerPartNumber: null,
                      manufacturers: [],
                      isFreeShipping: false,
                      picture: product.picture,
                      warehouse: product.warehouse,
                    }}
                  />
                ))}
              </div>
              {props.seeMoreTo && (
                <div className="mt-6 text-right">
                  <Link to={props.seeMoreTo} className="text-blue-600 hover:text-blue-700 text-sm font-medium">
                    See All →
                  </Link>
                </div>
              )}
            </div>
          ),
        }[props.layout]
      }
    </div>
  );
};

const Vertical = (props: { products: any[]; title: ReactNode }) => {
  return (
    <>
      {props.products && (
        <>
          {props.title}
          {props.products.map((i) => {
            const g: IProductSearchResult = {
              approvedRatingSum: i.approvedRatingSum,
              additionalShippingCharge: 0,
              id: i.id,
              name: i.name,
              seoName: i.seoName,
              partInterchange: [],
              priceAndAvailability: i.priceAndAvailability,
              manufacturerPartNumber: null,
              manufacturers: [],
              isFreeShipping: false,
              picture: i.picture,
              warehouse: i.warehouse,
            };
            return (
              <div key={i.id}>
                <ItemContainer listingType="SEARCH_RESULT" item={g} searchString={""} interchange={null} />
              </div>
            );
          })}
        </>
      )}
    </>
  );
};
export default Collection;
